import * as yup from 'yup'

const requiredMessage = 'Campo obrigatório'

export const requestSchema = yup.object({
  responsibleId: yup.string().required(requiredMessage),
  clientId: yup.string().required(requiredMessage),
  requesterId: yup.string().required(requiredMessage),
  projectName: yup.string().required(requiredMessage),
  enterAt: yup.string().required(requiredMessage).nullable(),
  assetId: yup.string().required(requiredMessage),
  analystId: yup.string().required(requiredMessage),
  description: yup.string().required(requiredMessage)
})
